import { TextApi } from 'platejs'
import type { EditorNodesOptions, TText, TextEntry } from 'platejs'

import { Service } from '~publish/legacy/constants/services/ServiceDefinitions'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { editorDebug } from '~publish/legacy/editor/editorDebug'

import { Url } from '../../../helpers/Url'
import { LinkElement } from '../nodes/LinkElement'

const debug = editorDebug.extend('plugins:link')

const isLinkTextChild = (
  editor: BufferEditor,
  [, path]: TextEntry,
): boolean => {
  const parent = editor.api.parent(path)

  return LinkElement.is(parent?.[0])
}

export const findAndWrapNewLinks = (
  editor: BufferEditor,
  options: Pick<EditorNodesOptions, 'at'> = {},
): void => {
  const textNodes = editor.api.nodes<TText>({
    at: [],
    ...options,
    match: (n, p) =>
      TextApi.isText(n) &&
      !!n.text &&
      Url.hasUrl(n.text) &&
      !isLinkTextChild(editor, [n, p]),
    mode: 'all',
    reverse: true,
  })

  Array.from(textNodes).forEach(([node, path]) => {
    Url.extractUrlsWithRange([node, path]).forEach(({ url, range }) => {
      const element = LinkElement.new({
        url,
        // editor.id is a plain string at runtime, always one of the Service
        // values (set to the SERVICE_* constant when the editor is created)
        ensureProtocol: [
          Service.Threads,
          Service.Mastodon,
          Service.Bluesky,
        ].includes(editor.id as Service),
      })

      if (element) {
        debug('wrapping link: %s at %o', url, range)
        editor.tf.insertNodes<LinkElement>(element, {
          at: range,
        })
      }
    })
  })
}
